import React from 'react';

/** Kurzer Klartext-Auszug (Markdown-Zeichen grob entfernt) fuer die Vorschau. */
const auszug = (text) =>
  (text || '')
    .replace(/[#*`>~[\]()-]/g, '')
    .trim()
    .slice(0, 220);

const datum = (iso) => (iso ? new Date(iso).toLocaleDateString('de-DE') : '');

/**
 * Dynamischer, reflowender Notiz-Bereich: Karten in einem automatisch
 * umbrechenden Masonry-Raster (CSS-Columns). Optional eine „Neue Notiz"-Kachel.
 */
export default function NotizBoard({ notizen, ordner, dateien, onOeffnen, onNeu, leerText }) {
  const ordnerFarbe = (id) => ordner.find((o) => o.id === id)?.farbe;
  const ordnerName = (id) => ordner.find((o) => o.id === id)?.name;
  const anzahlAnhaenge = (uuid) => dateien.filter((d) => d.notizUuid === uuid).length;

  if (notizen.length === 0 && !onNeu) {
    return (
      <p className="rounded-2xl border border-dashed border-line bg-paper-soft p-10 text-center text-ink-muted">
        {leerText || 'Keine Notizen hier.'}
      </p>
    );
  }

  return (
    <div className="columns-1 gap-4 sm:columns-2 lg:columns-3">
      {onNeu && (
        <button
          type="button"
          onClick={onNeu}
          className="mb-4 flex w-full break-inside-avoid items-center justify-center gap-2 rounded-2xl border border-dashed border-brand-300 bg-brand-50/40 px-4 py-6 text-sm font-medium text-brand-600 transition-colors hover:bg-brand-50"
        >
          <span className="text-lg">＋</span> Neue Notiz
        </button>
      )}

      {notizen.map((n) => {
        const anhaenge = anzahlAnhaenge(n.uuid);
        return (
          <button
            key={n.uuid}
            type="button"
            onClick={() => onOeffnen(n)}
            className="group mb-4 flex w-full break-inside-avoid flex-col rounded-2xl border border-line bg-paper p-4 text-left shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-brand-600/40 hover:shadow-md"
          >
            <div className="mb-1 flex items-start justify-between gap-2">
              <h3 className="line-clamp-2 font-serif font-semibold text-ink">{n.titel || 'Ohne Titel'}</h3>
              {n.favorit && <span className="shrink-0 text-amber-500">★</span>}
            </div>
            {auszug(n.text) && (
              <p className="line-clamp-6 whitespace-pre-wrap text-sm text-ink-muted">{auszug(n.text)}</p>
            )}
            {(n.tags || []).length > 0 && (
              <div className="mt-3 flex flex-wrap items-center gap-1.5">
                {(n.tags || []).slice(0, 4).map((t) => (
                  <span key={t} className="rounded-full bg-paper-sunken px-2 py-0.5 text-xs text-ink-muted">#{t}</span>
                ))}
              </div>
            )}
            <div className="mt-3 flex items-center justify-between gap-2 text-xs text-ink-muted">
              <span className="flex min-w-0 items-center gap-1.5">
                {n.ordnerId != null && (
                  <>
                    <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: ordnerFarbe(n.ordnerId) || '#64748b' }} />
                    <span className="truncate">{ordnerName(n.ordnerId)}</span>
                  </>
                )}
              </span>
              <span className="flex shrink-0 items-center gap-2">
                {anhaenge > 0 && <span title={`${anhaenge} Anhänge`}>📎 {anhaenge}</span>}
                <span>{datum(n.updatedAt)}</span>
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
